import React from 'react';
import '../style/Footer.css';
import logo from '../assets/logo.png';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-section about">
          <img src={logo} alt ='logo'/>
          <p>Save more with the best coupons and deals from top online stores. Your one-stop destination for daily discounts.</p>
        </div>

        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/coupons">All Coupons</a></li>
            <li><a href="/categories">Categories</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h3>Contact Us</h3>
          <p>Email: support@couponlagao.com</p>
          <p>Phone: +91-8791153542</p>
          <div className="footer-socials">
            <a href="https://www.facebook.com/"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.facebook.com/"><i className="fab fa-twitter"></i></a>
            <a href="https://www.instagram.com/"><i className="fab fa-instagram"></i></a>
            <a href="https://in.linkedin.com/"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} CouponLagao. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
